import { useState } from "react";
import { ArrowRight } from "lucide-react";
import FormModal from "@/components/FormModal";
import FadeInSection from "@/components/FadeInSection";

const NewsletterBanner = () => {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <>
      <FadeInSection>
        <div className="rounded-xl border border-primary/30 bg-gradient-to-r from-primary/10 via-primary/5 to-transparent p-6 md:p-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h3 className="text-lg font-bold text-foreground mb-1">
                Get the signal, not the noise.
              </h3>
              <p className="text-sm text-muted-foreground">
                Weekly prediction markets intelligence delivered to your inbox. Join 4,200+ readers. Free forever.
              </p>
            </div>
            <button
              onClick={() => setFormOpen(true)}
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-semibold text-sm px-5 py-2.5 rounded-lg hover:opacity-90 transition-opacity shrink-0"
            >
              Subscribe <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </FadeInSection>

      <FormModal
        isOpen={formOpen}
        onClose={() => setFormOpen(false)}
        title="Join the inner circle."
        subtitle="Get weekly prediction markets intelligence that the crowd does not see. Curated news, exclusive analysis, and early access to NEXTPredict research."
        incentive="🎁 Subscribers get first access to our reports, event invites, and summit ticket drops."
        formId="7e677eab-387c-4053-af96-df54a2e31344"
      />
    </>
  );
};

export default NewsletterBanner;
